/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskExclusionsUpdate } from "../funcs/riskExclusionsUpdate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskExclusion } from "../models/components/riskexclusion.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateRiskExclusionRequest,
  UpdateRiskExclusionSecurity,
} from "../models/operations/updateriskexclusion.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskUpdateExclusionMutationVariables = {
  request: UpdateRiskExclusionRequest;
  security?: UpdateRiskExclusionSecurity | undefined;
  options?: RequestOptions;
};

export type RiskUpdateExclusionMutationData = RiskExclusion;

export type RiskUpdateExclusionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateRiskExclusion risk
 *
 * @remarks
 * Update a risk exclusion.
 */
export function useRiskUpdateExclusionMutation(
  options?: MutationHookOptions<
    RiskUpdateExclusionMutationData,
    RiskUpdateExclusionMutationError,
    RiskUpdateExclusionMutationVariables
  >,
): UseMutationResult<
  RiskUpdateExclusionMutationData,
  RiskUpdateExclusionMutationError,
  RiskUpdateExclusionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskUpdateExclusionMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskUpdateExclusion(): MutationKey {
  return ["@gram/client", "exclusions", "update"];
}

export function buildRiskUpdateExclusionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskUpdateExclusionMutationVariables,
  ) => Promise<RiskUpdateExclusionMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskUpdateExclusion(),
    mutationFn: function riskUpdateExclusionMutationFn({
      request,
      security,
      options,
    }): Promise<RiskUpdateExclusionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskExclusionsUpdate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
